enum EvaluationStatus {
    PENDING = "pending",
    INPROGRESS = "inprogress",
    COMPLETE = "complete",
    INREVIEW = "inreview",
    RETRACTED = "retracted",
    CALIBRATION = "calibration",
    PARTIAL_RESPONSE = "partialResponse",
}

export default EvaluationStatus;
